<template>
  <div class="search-filter">
    <button
        v-for="status in statuses"
        :key="status"
        @click="onSelect(status)"
        @mouseover="onHover(status)"
        @mouseleave="onLeave"
        class="status-button"
        :class="getStatusClass(status)"
    >
      {{ status === 'ALL' ? 'All' : status }}
    </button>

  </div>
</template>

<script setup>
import {defineProps, ref} from 'vue'

const props = defineProps({
  selectedStatus: String
})
const emit = defineEmits(['update:selectedStatus'])

const statuses = ['ALL', 'Upcoming', 'Ongoing', 'Past']

const onSelect = (status) => {
  emit('update:selectedStatus', status)
}

const getStatusClass = (status) => {
  const effectiveStatus = hoveredStatus.value === status ? status : props.selectedStatus

  return {
    'selected-all': effectiveStatus === 'ALL' && status === 'ALL',
    'selected-upcoming': effectiveStatus === 'Upcoming' && status === 'Upcoming',
    'selected-ongoing': effectiveStatus === 'Ongoing' && status === 'Ongoing',
    'selected-past': effectiveStatus === 'Past' && status === 'Past',
  }
}

const hoveredStatus = ref(null)

const onHover = (status) => {
  hoveredStatus.value = status
}
const onLeave = () => {
  hoveredStatus.value = null
}

</script>

<style scoped>
.search-filter {
  display: flex;
  justify-content: space-around;
  gap: 10px;
  margin-bottom: 15px;
}

.status-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  width: clamp(74px, 8.0vw, 92px);
  height: clamp(29px, 6.0vw, 36px);

  background-color: transparent;
  border: 1px solid #878787;
  filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.6));
  border-radius: 5px;
  padding: 10px;
  color: #999999;

  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: clamp(11px, 2.6vw, 14px);
  letter-spacing: -0.03em;
  text-align: center;
  cursor: pointer;
  transition: all 0.5s ease;
  flex: 1;
}

/* 선택된 상태별 색상 적용 */
.selected-all {
  background-color: #ffffff;
  border-color: #ffffff;
  color: #000;
}

.selected-upcoming {
  background-color: #FF0042;
  border-color: #FF0042;
  color: #fff;
}

.selected-ongoing {
  background-color: #0900FF;
  border-color: #0900FF;
  color: #fff;
}

.selected-past {
  background-color: #878787;
  border-color: #878787;
  color: #fff;
}
</style>
